import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  DoneTradeToolService,
  Wealthlane_AwardService_Dtos_BrokerTradeTool_CreateExecutedDoneTradeDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePostCsExecutedDoneTrade = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (data: Wealthlane_AwardService_Dtos_BrokerTradeTool_CreateExecutedDoneTradeDto) => {
      return await handleRequest(
        DoneTradeToolService.postApiAwardApiAppCsDoneTradeToolCreateExecutedLongShareSell(data)
      );
    },
    {
      onSuccess: () => {
        toast.success(
          <ToastComponent label='Success' message='Done trade completed successfully.' />
        );
        void queryClient.invalidateQueries('getCsDoneTradeSellItems');
      },
    }
  );
};

export default usePostCsExecutedDoneTrade;